// extracted by mini-css-extract-plugin
export default {"Preamble":"index-module--Preamble--sls-S","Preamble--left":"index-module--Preamble--left--kjnbn","Preamble--center":"index-module--Preamble--center--qy5kV"};